import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig } from '@spartacus/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { provideDefaultConfig } from '../../../core/config';
import { GenericLinkModule } from '../../../shared/components/generic-link/generic-link.module';
import { LinkComponent } from './link.component';

@NgModule({
  imports: [CommonModule, RouterModule, GenericLinkModule, NzIconModule],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        CMSLinkComponent: { component: LinkComponent },
      },
    }),
  ],
  declarations: [LinkComponent],
  exports: [LinkComponent],
})
export class CmsLinkModule {}
